import { zodResolver } from '@hookform/resolvers/zod'
import { useNavigate } from '@tanstack/react-router'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { ClientDto } from '@/gen/publicApi'

import { Button } from '@/components/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/card'
import { Form } from '@/components/form'
import FormSelect from '@/components/form/formSelect'

import { useSetClientCode } from '@/state/clientCode'

interface Props {
    clients: ClientDto[]
}

export default function ClientSelector({ clients }: Props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const setClientCode = useSetClientCode()
    const navigate = useNavigate()

    const formSchema = z.object({
        clientCode: z.string(),
    })

    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        mode: 'onBlur',
    })

    const onSubmit = ({ clientCode }: z.infer<typeof formSchema>) => {
        setClientCode(clientCode)
        navigate({ to: `/$client_code`, params: { client_code: clientCode } })
    }

    return (
        <Card className="absolute-center w-96">
            <CardHeader>
                <CardTitle>Select a client</CardTitle>
                <CardDescription>
                    You've got access to more than one client. Select which one you'd like to use.
                </CardDescription>
            </CardHeader>
            <CardContent>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
                        <FormSelect
                            control={form.control}
                            name="clientCode"
                            label="Available clients"
                            placeholder="Select a client"
                            options={clients.map(c => ({ value: c.code, label: c.name }))}
                        />
                        <Button type="submit" disabled={!form.formState.isValid}>
                            Go
                        </Button>
                    </form>
                </Form>
            </CardContent>
        </Card>
    )
}
